<template>
  <div>
    <div class="heading">{{ $t('consumption_devices.page_title') }}</div>
    <NewGlassCard class="mt-16" :title="$t('consumption_devices.all_orders')">
      <template v-slot:back-button>
        <v-btn class="back-button mb-6" @click="goOnePageBack()"
          ><v-icon color="#6E6E6E">mdi-arrow-left</v-icon></v-btn
        >
      </template>
      <ConsumptionDevicesOverviewComponent />
    </NewGlassCard>
  </div>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import ConsumptionDevicesOverviewComponent from '../components/consumption-devices-overview-component/ConsumptionDevicesOverviewComponent.vue';

export default {
  name: 'ConsumptionDevicesPage',
  components: {
    ConsumptionDevicesOverviewComponent,
    NewGlassCard,
  },
  data() {
    return {
      ordersSummary: [],
    };
  },
  methods: {
    goOnePageBack() {
      const previousPage = this.$store.getters.getPreviousPage;
      if (previousPage) {
        this.$router.push(previousPage);
      } else {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped>
.heading {
  font-size: 50px;
  margin-bottom: 0;
}
.back-button {
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  height: 35px !important;
  width: 90px;
  box-shadow: none;
  margin-right: 30px;
}
</style>
